export const RouterPath = {
    dashboard:'/',
    changePassword:'/changePassword',
    setPassword:'/setPassword',
    settings:'/settings',
}